import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Pages.module.css';

const TermsOfService = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageHeader}>
        <div className={styles.container}>
          <Link to="/" className={styles.backLink}>← Back to Home</Link>
          <h1>Terms of Service</h1>
        </div>
      </div>
      
      <div className={styles.pageContent}>
        <div className={styles.container}>
          <section className={styles.section}>
            <h2>1. Introduction</h2>
            <p>
              Welcome to NexusStake — a cryptocurrency staking platform. By using our website and services, 
              you agree to these Terms of Service. Please read them carefully.
            </p>
            <p>
              These Terms of Service ("Terms") constitute a legally binding agreement between you 
              and NexusStake ("we", "us", "our") regarding your use of our website, located at 
              nexusstake.com, and all related services (collectively referred to as the "Service").
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>2. Definitions</h2>
            <p>
              <strong>"Content"</strong> means all text, images, videos, and other materials that we provide through the Service.
            </p>
            <p>
              <strong>"User Content"</strong> means all information that you provide when using the Service.
            </p>
            <p>
              <strong>"Staking"</strong> means the process of locking cryptocurrency assets to support blockchain 
              network operations and earn rewards.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>3. Acceptable Use</h2>
            <p>You agree to use the Service only for lawful purposes and in ways that do not infringe on the 
              rights of other users. You must not:</p>
            <ul>
              <li>Use the Service for any illegal activity or to facilitate illegal activity</li>
              <li>Violate any international, federal, provincial, or state regulations, laws, or local ordinances</li>
              <li>Interfere with or disrupt the security of the Service</li>
              <li>Distribute viruses or any other malicious code</li>
              <li>Impersonate another person or organization</li>
              <li>Collect or track personal information of other users</li>
            </ul>
          </section>
          
          <section className={styles.section}>
            <h2>4. Registration and Accounts</h2>
            <p>
              To access certain features of the Service, you may need to connect your cryptocurrency wallet. 
              You are responsible for maintaining the confidentiality of your access keys and for all activities 
              that occur using your wallet.
            </p>
            <p>
              You must immediately notify us of any unauthorized use of your wallet or any other 
              security breach. We are not responsible for any losses caused by someone else using your wallet, 
              with or without your knowledge.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>5. Staking and Financial Terms</h2>
            <p>
              NexusStake provides cryptocurrency staking services. By using our services, you acknowledge and agree to the following:
            </p>
            <ul>
              <li>Cryptocurrency staking involves risks, including but not limited to market price volatility, 
                smart contract technical risks, and regulatory risks</li>
              <li>Returns from staking are not guaranteed and may vary depending on various factors</li>
              <li>You are solely responsible for any tax obligations arising from using our services</li>
              <li>We may charge fees for services provided, which will be clearly indicated on our website</li>
              <li>Blockchain transaction fees are paid by the user and are independent of NexusStake</li>
            </ul>
          </section>
          
          <section className={styles.section}>
            <h2>6. Intellectual Property</h2>
            <p>
              The Service and its original content, features, and functionality are and will remain the exclusive property 
              of NexusStake and its licensors. The Service is protected by copyright, trademark, and other laws.
            </p>
            <p>
              Our trademarks and trade dress may not be used without our prior written permission.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>7. User Content</h2>
            <p>
              You retain all rights to your User Content. By providing User Content to the Service, 
              you grant us a worldwide, non-exclusive, royalty-free, sublicensable, and transferable license 
              to use, reproduce, distribute, create derivative works, display, and perform the 
              User Content in connection with the Service.
            </p>
            <p>
              You warrant that your User Content does not violate the rights of any third party, including 
              copyright, trademark, privacy, personality, or other personal or proprietary rights.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, NexusStake will not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, including but not limited to loss of profits, 
              data, use, reputation, or other intangible losses, resulting from:
            </p>
            <ul>
              <li>Your use of or inability to use the Service</li>
              <li>Any changes, prices, suspension, or termination of the Service</li>
              <li>Unauthorized access to, use of, or alteration of your data</li>
              <li>Statements or conduct of any third party on the Service</li>
              <li>Loss of cryptocurrency due to user error, wallet hacking, or blockchain issues</li>
            </ul>
          </section>
          
          <section className={styles.section}>
            <h2>9. Disclaimer of Warranties</h2>
            <p>
              The Service is provided "as is" and "as available" without any warranties, express or implied, including but 
              not limited to the implied warranties of merchantability, fitness for a particular purpose, 
              non-infringement, or course of performance.
            </p>
            <p>
              We do not guarantee that the Service will be secure, error-free, virus-free, or meet your requirements.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>10. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of the European Union, 
              without regard to its conflict of law provisions.
            </p>
            <p>
              Our failure to enforce any right or provision of these Terms will not be considered a waiver 
              of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, 
              the remaining provisions of these Terms will remain in effect.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
              If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
            </p>
            <p>
              By continuing to use our Service after those revisions become effective, you agree to be bound by the revised terms. 
              If you do not agree to the new terms, please stop using the Service.
            </p>
          </section>
          
          <section className={styles.section}>
            <h2>12. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us:
            </p>
            <ul className={styles.contactInfo}>
              <li>By email: support@nexusstake.com</li>
              <li>By mail: NexusStake, 123 Blockchain Street, Crypto City, 12345, European Union</li>
            </ul>
          </section>
          
          <div className={styles.lastUpdated}>
            Last updated: April 30, 2023
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 